import React from 'react'
import Menu from './Menu.js'
import Grid from "@material-ui/core/Grid";
import '../assets/css/Order.css'
import Table from '../components/Table/SearchOrderTable.js'
import Table2 from '../components/Table/SearchLenderTable.js'
import { NavLink } from "react-router-dom";
import Button from '@material-ui/core/Button';
class LookupOrder extends React.Component {

    render() {
        const { look_up } = this.props.location.state;
        return (
            <div style={{ backgroundColor: 'white' }}>
                <div>
                    <Grid container>
                        <Grid item xs={12}>
                            <Menu look_up={look_up} />
                        </Grid>
                    </Grid>
                </div>
                <div className="mdata">
                    <Grid container >
                        <Grid item xs={12}>
                           <h2 className="mtextOpenOrder">{this.props.location.lookupType === "Lender" ? "Lenders": "Orders"} Result</h2>
                        </Grid>
                    </Grid>
                    <NavLink to={ `/Orderlookup`}>
                        <div style={{textAlign: "right"}}>                        
                            <Button disabled variant="contained" style={{ boxShadow: '0px 3px 5px -2px #AAAAAA',outline: 'none', 
                                color: 'white', height: '50px', width: '120px', fontFamily: 'Roboto-Bold', 
                                backgroundColor: '#04AB23', textTransform: 'none', textAlign: 'center', marginBottom: '10px' }} 
                                >
                                Back
                            </Button>
                        </div>
                    </NavLink>
                    <Grid item xs={12}>
                        {this.props.location.lookupType === "Lender" 
                        ? <Table2 searchData = { this.props.location.lookupData } searchType = {this.props.location.lookupType} look_up={look_up} />
                        : <Table searchData = { this.props.location.lookupData } searchType = {this.props.location.lookupType} look_up={look_up} />}
                    </Grid>
                </div>
            </div>
        )
    }
}

export default LookupOrder;
